module.exports = __webpack_public_path__ + "/img/SOTFL-Labeled-PHOvXd.svg";